import { currencySchema } from "./currency.schema";
import { deliveryMethodSchema } from "./delivery-method.schema";

export const locationSchema = `
            id
            locationName
            locationLabel
            requiresBranch
            diallingCode
            deliveryMethods{
              ${deliveryMethodSchema}
            }
            currency {
                ${currencySchema}
            }
            flagUrl
            status
            createdDateTime
            modifiedDateTime
    `;
  
    
  
  
  
  
  
  